import { useEffect } from 'react';
import styles from './LogisticsPage.module.css';

interface ILogisticsBannerProps {
  message: string;
  /** Present only on the retryable failure — the not-found / not-linked
   *  banners have nothing to retry. */
  onRetry?: () => void;
  retryLabel?: string;
  /** The failure behind a failed load — logged for the developer, never
   *  shown: its text is the API's English route and the server's message. */
  detail?: unknown;
}

/** The page's whole-surface notice (not found, not linked, failed): one
 *  banner, so the three states cannot drift apart. */
export function LogisticsBanner({ message, onRetry, retryLabel, detail }: ILogisticsBannerProps) {
  useEffect(() => {
    if (detail !== undefined) console.error('logistics load failed', detail);
  }, [detail]);
  return (
    <div className={styles.banner} role="alert">
      <span>{message}</span>
      {onRetry ? (
        <button type="button" onClick={onRetry}>
          {retryLabel}
        </button>
      ) : null}
    </div>
  );
}
